import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { selectInStore } from '../../features/app/selectors'
import { selectUsername } from '../../features/auth/selectors'
import { selectDoctorPanel } from '../../features/panels/selectors'
import usersActions from '../../features/users/actions'
import { selectUserByUsername } from '../../features/users/selectors'
import { showDebugMode } from '../../libs/utils'
import { useTeloDispatch, useTeloSelector } from '../../store'
import Button from '../../styleguide/buttons/Button'
import TargetIcon from '../../styleguide/icons/TargetIcon'
import Switch from '../../styleguide/Switch'
import theme from '../../styleguide/theme'
import IconButton from '../../styleguide/buttons/IconButton'
import { DebugModeSwitch } from '../DebugMode'
import ProfileMenu from '../ProfileMenu'
import { RightCol } from './common'

const AvailabilitySwitch = styled(Switch)`
	color: ${props =>
		props.checked ? theme.palette.secondary.main : theme.palette.primary.main};
`

const MissionControlButtonStyled = styled(IconButton)<{
	$isappinsideeclips: boolean
}>(() => ({
	padding: 0,
	minWidth: 'auto',
	width: 'auto',
	'&.Mui-focusVisible': {
		outline: 'none !important',
	},
	'&:focus': {
		outline: 'none',
		boxShadow: 'none',
	},
	border: 'none',
}))

export type RightColumnContentProps = {
	hideUnavailable?: boolean
	isDoctor: boolean
	isRefractionist: boolean
	isWorklistPage: boolean
	isAppInsideEclips: boolean
	isMissionControlOpen?: boolean
	hideProfileMenu?: boolean
	openMissionControl?: () => void
}

export const RightColumnContent = ({
	hideUnavailable,
	isDoctor,
	isRefractionist,
	isWorklistPage,
	isAppInsideEclips,
	isMissionControlOpen,
	hideProfileMenu,
	openMissionControl,
}: RightColumnContentProps) => {
	const inStore = useTeloSelector(selectInStore)
	const username = useTeloSelector(selectUsername)
	const user = useTeloSelector(selectUserByUsername(username))
	const dispatch = useTeloDispatch()
	const { t } = useTranslation()
	const doctorPanel = useTeloSelector(selectDoctorPanel)

	const isPanelAssigned = doctorPanel.length > 0

	const showUnavailableButton =
		!hideUnavailable &&
		(isDoctor || (isRefractionist && !inStore)) &&
		isWorklistPage

	return (
		<RightCol>
			{showDebugMode === true ? <DebugModeSwitch /> : null}
			{showUnavailableButton && user && (
				<AvailabilitySwitch
					checked={user?.available}
					label={t('app.available')}
					onChange={() =>
						user &&
						dispatch(
							usersActions.setUserAvailability(user._id, !user.available),
						)
					}
				/>
			)}
			{isWorklistPage && ((isDoctor && isPanelAssigned) || !isDoctor) ? (
				<MissionControlButtonStyled
					$isappinsideeclips={isAppInsideEclips}
					onClick={openMissionControl}
				>
					<TargetIcon
						fill={
							isMissionControlOpen ? theme.palette.secondary.main : undefined
						}
					/>
				</MissionControlButtonStyled>
			) : null}
			{hideProfileMenu ? <span></span> : <ProfileMenu />}
		</RightCol>
	)
}
